var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "table" }, [
    _c(
      "div",
      { staticClass: "container" },
      [
        _c(
          "div",
          { staticClass: "handle-box" },
          [
            _c(
              "el-form",
              {
                attrs: {
                  model: _vm.queryCondition,
                  "label-position": _vm.labelPosition,
                  "label-width": "110px",
                },
              },
              [
                _c(
                  "el-row",
                  { attrs: { gutter: 16 } },
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 8 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "料架类型名称" } },
                          [
                            _c("el-input", {
                              staticClass: "handle-input",
                              attrs: { clearable: "" },
                              model: {
                                value: _vm.queryCondition.mateName,
                                callback: function ($$v) {
                                  _vm.$set(_vm.queryCondition, "mateName", $$v)
                                },
                                expression: "queryCondition.mateName",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 8 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "料架状态" } },
                          [
                            _c("el-input", {
                              staticClass: "handle-input",
                              attrs: { clearable: "" },
                              model: {
                                value: _vm.queryCondition.mateCode,
                                callback: function ($$v) {
                                  _vm.$set(_vm.queryCondition, "mateCode", $$v)
                                },
                                expression: "queryCondition.mateCode",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 8 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "料架唯一编码" } },
                          [
                            _c("el-input", {
                              staticClass: "handle-input",
                              attrs: { clearable: "" },
                              model: {
                                value: _vm.queryCondition.mateCode,
                                callback: function ($$v) {
                                  _vm.$set(_vm.queryCondition, "mateCode", $$v)
                                },
                                expression: "queryCondition.mateCode",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-row",
                  { attrs: { gutter: 16 } },
                  [
                    _c(
                      "el-col",
                      { attrs: { span: 8 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "料架类型编号" } },
                          [
                            _c("el-input", {
                              staticClass: "handle-input",
                              attrs: { clearable: "" },
                              model: {
                                value: _vm.queryCondition.mateCode,
                                callback: function ($$v) {
                                  _vm.$set(_vm.queryCondition, "mateCode", $$v)
                                },
                                expression: "queryCondition.mateCode",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 8 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "料架空满箱状态" } },
                          [
                            _c("el-input", {
                              staticClass: "handle-input",
                              attrs: { clearable: "" },
                              model: {
                                value: _vm.queryCondition.mateCode,
                                callback: function ($$v) {
                                  _vm.$set(_vm.queryCondition, "mateCode", $$v)
                                },
                                expression: "queryCondition.mateCode",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c(
                      "el-col",
                      { attrs: { span: 8 } },
                      [
                        _c(
                          "el-form-item",
                          { attrs: { label: "超期未周转" } },
                          [
                            _c("el-input", {
                              staticClass: "handle-input",
                              attrs: { clearable: "" },
                              model: {
                                value: _vm.queryCondition.mateCode,
                                callback: function ($$v) {
                                  _vm.$set(_vm.queryCondition, "mateCode", $$v)
                                },
                                expression: "queryCondition.mateCode",
                              },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                  ],
                  1
                ),
                _c(
                  "el-row",
                  { attrs: { gutter: 16 } },
                  [
                    _c(
                      "el-col",
                      { staticStyle: { "text-align": "center" } },
                      [
                        _c(
                          "el-button",
                          {
                            attrs: { type: "primary" },
                            on: { click: _vm.queryData },
                          },
                          [_vm._v("搜索")]
                        ),
                        _c("el-button", { attrs: { type: "primary" } }, [
                          _vm._v("重置"),
                        ]),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
        _c(
          "el-row",
          { staticClass: "action-btn-row" },
          [
            _c(
              "el-button",
              {
                attrs: { type: "primary" },
                on: { click: _vm.downloadMatePart },
              },
              [_vm._v("下载")]
            ),
          ],
          1
        ),
        _c(
          "el-table",
          {
            staticClass: "table",
            attrs: {
              data: _vm.tableData,
              border: "",
              "highlight-current-row": "",
            },
          },
          [
            _c("el-table-column", {
              attrs: {
                "show-overflow-tooltip": "",
                prop: "mateCode",
                label: "料架唯一编号",
              },
            }),
            _c("el-table-column", {
              attrs: {
                "show-overflow-tooltip": "",
                prop: "no",
                label: "料架类型编码",
              },
            }),
            _c("el-table-column", {
              attrs: {
                "show-overflow-tooltip": "",
                prop: "mateName",
                label: "料架名称",
              },
            }),
            _c("el-table-column", {
              attrs: {
                "show-overflow-tooltip": "",
                prop: "createDate",
                label: "当前库存节点编码",
              },
            }),
            _c("el-table-column", {
              attrs: {
                "show-overflow-tooltip": "",
                prop: "status",
                label: "当前库存节点名称",
              },
            }),
            _c("el-table-column", {
              attrs: {
                "show-overflow-tooltip": "",
                prop: "status",
                label: "料架状态",
              },
            }),
            _c("el-table-column", {
              attrs: {
                "show-overflow-tooltip": "",
                prop: "status",
                label: "空满箱状态",
              },
            }),
            _c("el-table-column", {
              attrs: {
                "show-overflow-tooltip": "",
                prop: "status",
                label: "未周转天数",
              },
            }),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "pagination" },
          [
            _c("el-pagination", {
              attrs: { layout: "prev, pager, next", total: _vm.total },
              on: { "current-change": _vm.handleCurrentChange },
            }),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }